// form
import { Input } from '@/components/ui';
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from '@/utils/Functions';

// ----------------------------------------------------------------------

type IProps = {
    name: string;
    onChange?: (value: any) => void;
    placeholder?: string;
    type?: string;
    disabled?: boolean;
    showError?: boolean;
} & React.ComponentProps<"input">;

export default function RHFTextField({ 
    name, 
    onChange, 
    className = '', 
    placeholder,
    type = 'text',
    disabled = false,
    showError = true,
    ...other 
}: IProps) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <div className="w-full h-full">
                    
                    <Input
                        {...field}
                        {...other}
                        id={name}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        value={field.value ?? ''}
                        className={cn("w-full h-full py-2", {
                            "border-red-500": error,
                            "bg-gray-100 cursor-not-allowed": disabled,
                            "border-white/20": !error,
                            "bg-transparent": !disabled,
                        }, className)
                        }
                        onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            if (onChange) {
                                onChange(value);
                            }
                        }}
                    />
                    {showError && error && (
                        <p className="mt-1 text-sm text-red-500">{error.message}</p>
                    )}
                </div>
            )}
        />
    );
}
